import { motion } from "framer-motion";
import heroVideo from "@/assets/videos/hero-bg.mp4";

interface HeroSectionProps {
  videoUrl?: string | null;
  ornamentUrl?: string;
}

export function HeroSection({ videoUrl, ornamentUrl }: HeroSectionProps) {
  return (
    <section
      id="hero"
      className="relative h-screen w-full overflow-hidden flex items-center justify-center"
    >
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          key={videoUrl}
          autoPlay
          muted
          loop
          playsInline
          className="h-full w-full object-cover opacity-80"
        >
          {/* Nature/Forest vibe video stock */}
          <source src={videoUrl || heroVideo} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-stone-900/30" /> {/* Overlay */}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-lg md:text-xl tracking-widest uppercase mb-4 opacity-90">
            The Wedding of
          </p>
          <h1 className="font-handwriting text-6xl md:text-8xl mb-6 text-[#F9F7F2] drop-shadow-md">
            Rifa & Nauval
          </h1>
          <div className="flex flex-col items-center gap-2 mt-8">
            {ornamentUrl ? (
              <img
                src={ornamentUrl}
                alt="Decoration"
                className="w-48 h-auto mb-4 opacity-90 brightness-0 invert"
              />
            ) : (
              <div className="h-16 w-[1px] bg-white/70 mb-2"></div>
            )}
            <p className="text-xl md:text-2xl font-serif italic">
              Februari 15, 2026
            </p>
            <p className="text-sm tracking-wide uppercase mt-2 opacity-80">
              Ponyo Malabar, Bandung
            </p>
            <p className="text-xs md:text-sm tracking-widest font-semibold mt-6 opacity-70">
              #RIFAllforeverwithNAUVAL
            </p>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-28 left-1/2 -translate-x-1/2 z-10"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-1">
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </div>
      </motion.div>
    </section>
  );
}
